import React, { useState, useEffect, useRef } from 'react';
import '../pages/portfolio.css';
import { useCommonVars } from './useCommonVars';

function PortfolioPage({
  user,
  userDetails,
  isCollecting,
  errorMessage,
  showSuccessAlert,
  showErrorAlert,
  setShowErrorAlert,
  handleCollectSavings,
  handleReinvest, btc, usdt, ton, eth
}) {
  const [isPressedReinvest, setIsPressedReinvest] = useState(false);
  const [isPressedCollect, setIsPressedCollect] = useState(false);
  const [showReinvestModal, setShowReinvestModal] = useState(false);
  const [amount, setAmount] = useState('');
  const [accrualTimer, setAccrualTimer] = useState('00:00:00');
  const { channelUrl, chatUrl, supportUrl, investPercent } = useCommonVars(user);

  const inputRef = useRef(null);
  const [modalTop, setModalTop] = useState(false);

  useEffect(() => {
    const updateTimer = () => {
      const now = new Date();
      const nextHourUtc = new Date(
        Date.UTC(
          now.getUTCFullYear(),
          now.getUTCMonth(),
          now.getUTCDate(),
          now.getUTCHours() + 1,
          0, 0, 0
        )
      );
      const diffMs = nextHourUtc.getTime() - now.getTime();
      const totalSeconds = Math.max(0, Math.floor(diffMs / 1000));
      const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
      const seconds = String(totalSeconds % 60).padStart(2, '0');
      setAccrualTimer(`${hours}:${minutes}:${seconds}`);
    };
    updateTimer();
    const intervalId = setInterval(updateTimer, 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    let visualResizeHandler;
    if (showReinvestModal) {
      visualResizeHandler = () => {
        if (
          typeof window.visualViewport !== "undefined" &&
          window.visualViewport.height < window.innerHeight - 90
        ) {
          setModalTop(true);
        } else {
          setModalTop(false);
        }
      };
      if (typeof window.visualViewport !== "undefined") {
        window.visualViewport.addEventListener('resize', visualResizeHandler);
      }
    }
    return () => {
      if (typeof window.visualViewport !== "undefined") {
        window.visualViewport.removeEventListener('resize', visualResizeHandler);
      }
    };
  }, [showReinvestModal]);

  return (
    <>
      <div className="main-container">
        <div className="deposit-card">
          <div className="deposit-label">Ваш депозит</div>
          <div className="deposit-balance">{userDetails?.deposit !== undefined
            ? userDetails.deposit.toLocaleString("ru-RU", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }) + "₽"
            : "0,00₽"}</div>
          <div className="deposit-line yield">Доходность: {investPercent}% / сутки</div>
          <div className="deposit-line accrued">
            Накоплено: <span className="value-white">{userDetails?.savings !== undefined
              ? userDetails.savings.toLocaleString("ru-RU", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) + "₽"
              : "0,00₽"}</span>
          </div>
          <div className="deposit-line timer">
            До сбора: <span className="value-white">{accrualTimer}</span>
          </div>
          <div className="deposit-buttons">
            <button
              className={`btn-reinvest ${isPressedReinvest ? 'pressed' : ''}`}
              onMouseDown={() => setIsPressedReinvest(true)}
              onMouseUp={() => {
                setIsPressedReinvest(false);
                setShowReinvestModal(true);
              }}
              onTouchStart={() => setIsPressedReinvest(true)}
              onTouchEnd={() => {
                setIsPressedReinvest(false);
                setShowReinvestModal(true);
              }}
            >
              Реинвест
            </button>
            <button
              className={`btn-collect ${isPressedCollect ? 'pressed' : ''}`}
              onMouseDown={() => !isCollecting && setIsPressedCollect(true)}
              onMouseUp={() => setIsPressedCollect(false)}
              onTouchStart={() => !isCollecting && setIsPressedCollect(true)}
              onTouchEnd={() => setIsPressedCollect(false)}
              onClick={handleCollectSavings}
              disabled={isCollecting}
            >
              {isCollecting ? "Сбор..." : "Собрать"}
            </button>
          </div>
        </div>
        <div className="info-section">
          <div className="info-title">Информация</div>
          <div className="info-support">
              <div className="support-links">
                <a href={supportUrl} target="_blank" rel="noopener noreferrer" className="support-link" title="Поддержка">
                  <span className="icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M4 15V11C4 6.582 7.582 3 12 3C16.418 3 20 6.582 20 11V15" stroke="currentColor" strokeWidth="2"/>
                      <rect x="2" y="15" width="5" height="6" rx="2" stroke="currentColor" strokeWidth="2"/>
                      <rect x="17" y="15" width="5" height="6" rx="2" stroke="currentColor" strokeWidth="2"/>
                      <path d="M12 21V19" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </span>
                  Поддержка
                </a>
                <span className="dot-sep">·</span>
                <a href={channelUrl} target="_blank" rel="noopener noreferrer" className="support-link" title="Канал">
                  <span className="icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M21 3L3 10.53L8.38 12.06L18.25 6.03C18.66 5.78 19.08 6.22 18.82 6.62L12.38 16.5V16.5L12.37 16.5L12.38 16.5V16.5L14.12 20.16C14.34 20.62 14.97 20.65 15.24 20.21L21 3Z" fill="currentColor"/>
                    </svg>
                  </span>
                  Канал
                </a>
                <span className="dot-sep">·</span>
                <a href={chatUrl} target="_blank" rel="noopener noreferrer" className="support-link" title="Чат">
                  <span className="icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M21 11.5C21 16.1944 16.9706 20 12 20C10.5709 20 9.22432 19.7453 8.02781 19.2929L3 20.5L4.20711 15.6725C3.44217 14.5208 3 13.0716 3 11.5C3 6.80558 7.02944 3 12 3C16.9706 3 21 6.80558 21 11.5Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                    </svg>
                  </span>
                  Чат
                </a>
              </div>
            </div>
          <div className="info-subtitle">Партнерская программа</div>
          <div className="info-icons-box">
            <img src={btc} alt="btc" className="coin-icon" />
            <img src={usdt} alt="usdt" className="coin-icon" />
            <img src={ton} alt="ton" className="coin-icon" />
            <img src={eth} alt="eth" className="coin-icon" />
          </div>
          <div className="copyright">© 2025 | Все права защищены.</div>
        </div>
      </div>
      {showReinvestModal && (
        <div className={`modal-overlay${modalTop ? " overlay-top" : ""}`}>
          <div className={`modal${modalTop ? " modal-top" : ""}`}>
            <div className="modal-title">Реинвестировать</div>
            <div
              className="modal-balance"
              onClick={() => {
                if (userDetails?.balance !== undefined) {
                  const cleanValue = userDetails.balance
                    .toFixed(2)
                    .replace('.', ',');
                  setAmount(cleanValue);
                }
              }}
              style={{ cursor: 'pointer' }}
            >
              Баланс: {userDetails?.balance !== undefined
                ? userDetails.balance.toLocaleString("ru-RU", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) + "₽"
                : "0,00₽"}
            </div>
            <div className="modal-input">
              <input
                ref={inputRef}
                type="text"
                inputMode="decimal"
                className="amount-input"
                placeholder="Введите сумму"
                value={amount}
                onFocus={() => setModalTop(true)}
                onBlur={() => setModalTop(false)}
                onChange={(e) => {
                  let value = e.target.value
                    .replace(/[^0-9.,]/g, '')
                    .replace(/([.,]).*?\1/g, '$1');
                  setAmount(value);
                }}
              />
            </div>
            <div className="modal-buttons">
              <button className="btn-cancel1" onClick={() => setShowReinvestModal(false)}>Отмена</button>
              <button
                className="btn-confirm1"
                onClick={() => {
                  handleReinvest(amount);
                  setShowReinvestModal(false);
                }}
              >
                Подтвердить
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PortfolioPage;










